/**
 * Copyright (c) 2025 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : contact-form.jsx
 * description   : {{insert here}}
 * creation date : 23/03/2025
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Html,
    Head,
    Body,
    Font,
    CodeBlock,
} from '@react-email/components';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function ContactFormEmail({ name, email, message, timestamp }) {
    return (
        <Html
            lang='en'
        >
            <Head>
                <>
                    <Font
                        fallbackFontFamily='monospace'
                        fontFamily='CommitMono'
                        fontStyle='normal'
                        fontWeight={400}
                        webFont={
                            {
                                url: 'https://react.email/fonts/commit-mono/commit-mono-regular.ttf',
                                format: 'truetype',
                            }
                        }
                    />
                </>
            </Head>

            <Body>
                <>
                    ---------
                    <CodeBlock
                        code={name}
                        fontFamily='"CommitMono", monospace'
                        language='javascript'
                        theme={{}}
                    />
                    ---------
                    <CodeBlock
                        code={email}
                        fontFamily='"CommitMono", monospace'
                        language='javascript'
                        theme={{}}
                    />
                    ---------
                    <CodeBlock
                        code={message}
                        fontFamily='"CommitMono", monospace'
                        language='javascript'
                        theme={{}}
                    />
                    ---------
                    <CodeBlock
                        code={timestamp.toString()}
                        fontFamily='"CommitMono", monospace'
                        language='javascript'
                        theme={{}}
                    />
                    ---------
                </>
            </Body>
        </Html>
    );
}



// --------------------------------------------------------------------------------
//      PREVIEW PROPS
// --------------------------------------------------------------------------------

ContactFormEmail.PreviewProps =
{
    name: 'John DOE',
    email: 'john.doe@email.com',
    message:
        (
            [
                'line 1',
                'line 2',
            ]
        ).join('\r'),
    timestamp: new Date('2025-03-29T19:17:13+01:00'),
};



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default ContactFormEmail;



// End of file
